<!-- <img *ngIf="photo != '' && photo != 'data:image/png;base64,'" class="photo"  /> -->
<!-- <i style="border: 1px solid #2196f3; color: #2196f3;" *ngIf="photo != '' && photo != 'data:image/png;base64,'" class="material-icons upload-icon"(click)="viewConditionPhoto()"  matTooltip="View/Edit Photo">add_a_photo</i>
<i *ngIf="(photo == '' ) || photo == 'data:image/png;base64,' " class="material-icons upload-icon" matTooltip="Add Photo">add_a_photo</i>
<input style="display: none; " type="file" #fileInput (change)="onSelectPhoto($event)" />
<mat-spinner diameter="24" *ngIf="photoLoading"></mat-spinner> -->


<div>&nbsp;</div>